var map = {
	"./BloodsInvestigations.png": 51,
	"./DiagnosticServicesInner.png": 52,
	"./HealthHygieneServicesInner.png": 53,
	"./LifestyleMentors.png": 94,
	"./LifestyleMentorsInner.png": 38,
	"./OPDFacility.png": 54,
	"./Pharmacy.png": 55,
	"./SleepConsultation.png": 95,
	"./SleepConsultationInner.png": 39,
	"./SleepDiagnostics.png": 96,
	"./SleepHealthHygiene.png": 97,
	"./SleepTreatment.png": 98,
	"./SpirometryLab.png": 56,
	"./TreatmentServicesInner.png": 40
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 268;